export default __webpack_public_path__ + "static/media/WB_Mimic.51ba3a74.gif";